<template>
<b-row class="risk-factors no-gutters">

    <b-col class="tool-border" cols="12">
        <tedtfHeader :image="'riskFactors'" :screenTitle="'Risk Factors You Can Change'"></tedtfHeader>
        <b-col class="page-background-gradient reduce-padding" cols="12">
            <b-row class="page-content no-gutters">
                <div class="body-sec">
                    <b-col class="reduce-padding" cols="12">
                        <div class="main-text">
                            <p>There are some things you can change to help reduce your risk of a TED flare. </p>
                        </div>
                    </b-col>

                    <b-col class="reduce-padding" cols="12">
                        <b-col class="reduce-padding" cols="12">
                            <b-row class="no-gutters">
                                <b-col class="left-col" lg="6" md="6" cols="12">
                                    <b-row class="no-gutters">
                                        <div class="img-area">
                                            <div class="stop-smoking"></div>

                                            <div class="table-cell ">
                                                <p class="smoking-heading">Stop Smoking</p>
                                                <div class="smoking-text">TED patients who smoke have higher flare rates than those who do not smoke.</div>
                                            </div>
                                        </div>
                                    </b-row>
                                    <b-row class="no-gutters">
                                        <div class="img-area">
                                            <div class="control-ted"></div>
                                            <div class="table-cell">
                                                <p class="control-heading">Control TED</p>
                                                <div class="control-text">Getting TED under control may reduce the risk of flares.</div>
                                            </div>
                                        </div>
                                    </b-row>


                                </b-col>
                                <b-col class="right-col" lg="6" md="6" cols="12">

                                    <b-row class="no-gutters">
                                        <div class="img-area">
                                            <div class="avoid-eye"></div>
                                            <div class="table-cell">
                                                <p class="avoid-heading">Avoid Eye Trauma</p>
                                                <div class="avoid-text">Avoid injuries to your eyes. Before deciding on eye surgery,
                                                    talk with your doctor about whether this could trigger a TED flare.</div>
                                            </div>
                                        </div>
                                    </b-row>


                                    <b-row class="no-gutters row-margin">
                                        <div class="img-area">
                                            <div class="throat-infection"></div>
                                            <!--<div class="text-area">-->
                                            <div class=" table-cell">
                                                <div class="head-width">
                                                  <p class="throat-heading">  Control Changing Thyroid Levels 
                                                  </p>
                                                  </div>

                                                <div class="throat-text">Changing thyroid levels can be a trigger for TED flares.
                                                    Consult with your doctor to ensure that your thyroid levels are under control. </div>
                                            </div>
                                            <!--</div>-->
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>


                        </b-col>


                    </b-col>

                </div>
            </b-row>
        </b-col>
        <tedftNavigation v-bind:navButtons="['next','back', 'showMidCol']" :currentScreen="3" :isSymptom="true" :isHideMenu="false"></tedftNavigation>
    </b-col>

</b-row>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
    import tedtfHeader from '../components/tedtfHeader.vue';
    import tedftNavigation from '../components/tedftNavigation.vue';

    export default {
        name: "riskFactors",
        mounted: function() {},
        components: {
            'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation
        },

        computed: {
            // ...mapGetters('userData', ['userData'])
        },

        methods: {},

        data() {
            return {};
        },
    };
</script>


<style lang="scss" scoped>
</style>
